export enum ActionableItemsDropDownEnum {
  Normalize = "Normalize",
  Extraction = "Extraction",
  Interception = "Interception"
}